module.exports = __webpack_public_path__ + "media/img/seed/7-24fc0337779ca2375746b444c4bbb2f3.jpeg";